import { useMemo } from "react";
import { useSelector } from "react-redux"
import { getQueue, getQueuePointer } from "../../reducers/randomMode"

export const useUpdateRandomQueueDisplayer = () => {
    const queue = useSelector(getQueue);
    const queuePointer = useSelector(getQueuePointer);

    const { emptyQueue, currentAlbum, previousAlbums, nextAlbums } = useMemo(() => {
        const emptyQueue = !queue || queue.length === 0;

        const actualQueuePointer = queuePointer - 1;
        let currentAlbum = undefined;
        if(actualQueuePointer >= 0 && actualQueuePointer < queue.length)
        {
            currentAlbum = queue[actualQueuePointer];
        }

        const previousAlbums = actualQueuePointer >= 0 ? queue.slice(0, actualQueuePointer) : [];
        const nextAlbums = queue.slice(actualQueuePointer + 1, queue.length);

        return { emptyQueue, currentAlbum, previousAlbums, nextAlbums };
    }, [queue, queuePointer]);

    return { queuePointer, emptyQueue, previousAlbums, currentAlbum, nextAlbums };
}